import { Box, Grid, Typography } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';
import { ARROW, BASEURL } from '../../../../constants/Common';
import axios from 'axios';
import { useEffect, useState } from 'react';
import FloatingButton from '../../helpdesk/FloatingButton';

export interface TrainingResource {
  id: number;
  date_of_register: string;
  type_of_course: string;
  user: {
    id: number;
    username: string;
    email: string;
  };
}

export default function TrainingRegister() {
  const [trainingResources, setTrainingResources] = useState<TrainingResource[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const location = useLocation();
  const UserId = JSON.parse(localStorage.getItem('authData') || 'null');
  const { Planname } = location.state || '';

  console.log('Planname:', Planname);

  const fetchTrainingResources = async () => {
    try {
      const response = await axios.get(BASEURL + `/trainingresources/${UserId}/`);
      const trainingResourceData = response.data;
      console.log('trainingresource', trainingResourceData);

      if (trainingResourceData.training_resources && trainingResourceData.training_resources.length > 0) {
        const resources = trainingResourceData.training_resources.map((resource: any) => ({
          ...resource,
          user: trainingResourceData.user,
        }));
        setTrainingResources(resources);
      }
      setLoading(false);
    } catch (error) {
      console.error('Error fetching training resource:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTrainingResources();
  }, []);

  if (loading) {
    return <p>Loading...</p>;
  }

  if (trainingResources.length === 0) {
    return <p>No training resource found.</p>;
  }

  // Filter the training resources to only include the one that matches Planname
  const filteredResources = trainingResources.filter(resource => resource.type_of_course === Planname);

  if (filteredResources.length === 0) {
    return <p>No training resource found for the specified plan.</p>;
  }

  return (
    <Box sx={{ mt: '-50px' }}>
      <Typography variant='h6' gutterBottom>
        <Link to='/usersupporthome'>User Support</Link> {ARROW} Training
      </Typography>
      <Grid>
        <Typography variant='h6'>
          You have successfully registered for the webinar. Below are the details:
        </Typography>
      </Grid>
      {filteredResources.map((resource) => (
        <Grid container key={resource.id} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={6}>
            <strong>Name:</strong>
          </Grid>
          <Grid item xs={6}>
            {resource.user.username}
          </Grid>
          <Grid item xs={6}>
            <strong>Course:</strong>
          </Grid>
          <Grid item xs={6}>
            {resource.type_of_course}
          </Grid>
          <Grid item xs={6}>
            <strong>Date of Registration:</strong>
          </Grid>
          <Grid item xs={6}>
            {resource.date_of_register ? resource.date_of_register.split('T')[0] : ''}
          </Grid>
        </Grid>
      ))}
      <FloatingButton />
    </Box>
  );
}
